import {
  getOrSetOrganizationState,
  getOrSetOrganizationPermissions
} from "@/utils/permission";

const userData = {
  manageShellState(isLoggedIn, commit, user, axios) {
    /*
    This method will be called in every login and logout.
    Host of this module must apply these mutations

    Available mutations ( <mutation_name>, <payload> )
    'shell/SET_FULL_NAME', <str:full_name>
    'shell/SET_EMAIL', <str:email>
    'shell/SET_PICTURE', <str:url>
    'shell/SET_SWITCHABLE_ORGANIZATIONS>', <Array: organization_array>
    'shell/SET_CURRENT_ORGANIZATION_NAME', <str:name>
    'shell/SET_CURRENT_ORGANIZATION_ID', <str/number:id>
    'shell/SET_CURRENT_ORGANIZATION_PERMISSIONS>', <Array: permission_string>
    'shell/CLEAR_ORGANIZATION_DATA>', <NO PAYLOAD>
  */

    if (isLoggedIn) {
      axios.setHeader(
        "Current-Organization",
        user.is_superuser
          ? user.scoped_organizations[0].slug
          : user.organization_slug
      );
    }

    if (isLoggedIn) {
      commit("shell/SET_FULL_NAME", user.name);
      commit("shell/SET_PICTURE", user.picture);
      commit("shell/SET_EMAIL", user.email);
      commit("shell/SET_SWITCHABLE_ORGANIZATIONS", user.scoped_organizations);
      commit(
        "shell/SET_CURRENT_ORGANIZATION_NAME",
        user.is_superuser
          ? user.scoped_organizations[0].name
          : user.organization_name
      );
      commit(
        "shell/SET_CURRENT_ORGANIZATION_ID",
        user.is_superuser
          ? user.scoped_organizations[0].slug
          : user.organization_slug
      );
      commit(
        "shell/SET_USER_ORGANIZATION_NAME",
        user.is_superuser ? "Super Organization" : user.organization_name
      );
      commit(
        "shell/SET_USER_ORGANIZATION_ID",
        user.is_superuser ? "superorganization" : user.organization_slug
      );
      getOrSetOrganizationState(axios, commit, {});
      axios
        .$get(`/api/v1/permission/org-request-user-constants/`)
        .then(response => {
          getOrSetOrganizationPermissions(commit, response);
        });
    } else {
      commit("shell/CLEAR_ORGANIZATION_DATA");
      getOrSetOrganizationPermissions(commit, []);
    }

    if (!isLoggedIn) {
      localStorage.removeItem("currentOrganizationInfo");
      localStorage.removeItem("currentPermission");
    }
  }
};

export default userData;
